import { InjectionToken } from '@angular/core';

export interface CapicheTextProcessorConfig {
  envName: string;
  baseApiUrl: string;
}

export const CAPICHE_TEXT_PROCESSOR_CONFIG = new InjectionToken<CapicheTextProcessorConfig>(
  'CapicheTextProcessorConfig',
);
